export default __webpack_public_path__ + "static/media/wood-chest-close-tab.ed1c83b0.png";